{
  "page": {
    "title": "Tareo",
    "subtitle": "La asistencia de cada trabajador por día, evaluada contra su horario.",
    "timezoneHint": "Días y horas en la zona de la sede de cada día.",
    "error": {
      "title": "No pudimos cargar el tareo",
      "description": "Inténtalo de nuevo en unos segundos."
    },
    "empty": {
      "title": "No hay trabajadores para mostrar",
      "description": "Nadie de tu alcance tuvo días en este período."
    },
    "noResults": {
      "title": "Sin resultados",
      "description": "Ningún trabajador coincide con los filtros aplicados."
    },
    "forbidden": {
      "title": "No tienes acceso al tareo",
      "description": "Necesitas ver marcaciones y horarios para consultar el tareo."
    },
    "hint": "Elige una celda para ver el detalle del día."
  },
  "filters": {
    "legend": "Filtros del tareo",
    "fromDay": "Desde",
    "toDay": "Hasta",
    "site": "Sede",
    "allSites": "Todas las sedes",
    "worker": "Trabajador",
    "allWorkers": "Todos los trabajadores",
    "workerSearch": "Buscar trabajador",
    "status": "Estado",
    "allStatuses": "Todos los estados",
    "statusCount": "{count} estados",
    "search": "Buscar por nombre o documento",
    "rangeRequired": "Elige las fechas desde y hasta.",
    "rangeInverted": "La fecha final no puede ser anterior a la inicial.",
    "rangeTooLong": "El período puede tener como máximo {max} días."
  },
  "matrix": {
    "label": "Tareo por trabajador y día",
    "worker": "Trabajador",
    "totals": "Totales",
    "cellLabel": "{day}: {status}",
    "minutes": "{minutes} minutos",
    "justified": "justificada",
    "changedAfterClosure": "cambió después del cierre",
    "outside": "{day}: sin datos (fuera de la relación laboral o de tu alcance)",
    "holidayHeader": "feriado: {name}"
  },
  "codes": {
    "legend": "Leyenda de códigos",
    "item": "{code}: {status}"
  },
  "status": {
    "ON_TIME": "A tiempo",
    "LATE": "Tardanza",
    "EARLY_LEAVE": "Salida anticipada",
    "LATE_AND_EARLY_LEAVE": "Tardanza y salida anticipada",
    "INCOMPLETE": "Incompleto",
    "ABSENT": "Falta",
    "ABSENT_JUSTIFIED": "Falta justificada",
    "UNSCHEDULED_WORK": "Marcó sin turno",
    "REST": "Descanso",
    "HOLIDAY": "Feriado",
    "PERMISSION": "Permiso",
    "VACATION": "Vacaciones",
    "LICENSE": "Licencia",
    "MEDICAL_LEAVE": "Descanso médico",
    "NO_SCHEDULE": "Sin horario",
    "PENDING": "Pendiente"
  },
  "flags": {
    "LATE": "Tardanza",
    "EARLY_LEAVE": "Salida anticipada",
    "INCOMPLETE": "Sin salida",
    "CHECKOUT_WITHOUT_CHECKIN": "Salida sin entrada",
    "OTHER_SITE": "Marcó en otra sede",
    "OUT_OF_SHIFT_MARKS": "Marcas fuera de turno",
    "PARTIAL_ABSENCE": "Falta parcial",
    "PARTIAL_PERMISSION": "Permiso parcial",
    "ON_HOLIDAY": "Trabajó en feriado",
    "ON_REST": "Trabajó en descanso",
    "WORKED_DURING_ABSENCE": "Trabajó durante su ausencia",
    "LATE_JUSTIFIED": "Tardanza justificada",
    "EARLY_LEAVE_JUSTIFIED": "Salida anticipada justificada",
    "ABSENCE_JUSTIFIED": "Falta justificada"
  },
  "totals": {
    "short": {
      "scheduled_days": "Prog.",
      "attended_days": "Asist.",
      "absences": "Faltas",
      "absences_justified": "F. just.",
      "lates": "Tard.",
      "early_leaves": "Sal. ant.",
      "worked_minutes": "Horas"
    },
    "long": {
      "scheduled_days": "Días programados",
      "attended_days": "Días asistidos",
      "absences": "Faltas",
      "absences_justified": "Faltas justificadas",
      "lates": "Tardanzas (minutos)",
      "early_leaves": "Salidas anticipadas (minutos)",
      "worked_minutes": "Horas trabajadas"
    },
    "countWithMinutes": "{count} · {minutes} min",
    "rowLabel": "Totales de {worker}"
  },
  "drawer": {
    "title": "Detalle del día",
    "description": "{worker} · {day}",
    "notFound": "No encontramos este día. Puede estar fuera de tu alcance o de la relación laboral.",
    "error": "No pudimos cargar el detalle del día.",
    "site": "Sede del día: {site}",
    "live": "En curso: se recalcula hasta que el día termine.",
    "summary": {
      "late": "Tardanza",
      "earlyLeave": "Salida anticipada",
      "worked": "Horas trabajadas",
      "scheduled": "Horas programadas",
      "minutes": "{minutes} min"
    },
    "evaluatedAgainst": "Evaluado contra",
    "noPlan": "Sin horario asignado ese día.",
    "rest": "Descanso asignado.",
    "off": "Sin turno ese día.",
    "shift": "{name} ({code}) v{version} · {range}",
    "crossesMidnight": "(termina al día siguiente)",
    "tolerance": "Tolerancia: tardanza {late} min · salida {early} min",
    "break": "Refrigerio {minutes} min",
    "shiftResult": {
      "attended": "Asistió",
      "missed": "No asistió",
      "late": "{minutes} min de tardanza",
      "earlyLeave": "{minutes} min de salida anticipada"
    },
    "assignment": "Asignación del {date} · {origin}",
    "assignmentBy": "Asignación del {date} · {origin} · por {name}",
    "origin": {
      "GRID": "Cuadro de turnos",
      "PATTERN": "Patrón",
      "INTEGRATION": "Integración"
    },
    "rules": "Reglas de cálculo v{version} · ventana de atribución {window} min · tolerancia de la empresa {late}/{early} min",
    "marks": "Marcas del día",
    "noMarks": "No hay marcas este día.",
    "markType": {
      "CHECK_IN": "Entrada",
      "CHECK_OUT": "Salida"
    },
    "markUsed": "Usada",
    "markUnused": "No usada",
    "markUnusedHelp": "fuera de turno",
    "holidayAbsence": "Ausencia y feriado",
    "holiday": "Feriado: {name}",
    "noHolidayAbsence": "Sin feriado ni ausencia.",
    "absenceType": {
      "PERMISSION": "Permiso",
      "VACATION": "Vacaciones",
      "LICENSE": "Licencia",
      "MEDICAL_LEAVE": "Descanso médico"
    },
    "absenceDays": "{type} del {from} al {to}",
    "absenceHours": "{type} de {start} a {end}",
    "absenceCancelled": "(cancelada)",
    "justifications": "Justificaciones",
    "noJustifications": "Sin justificaciones.",
    "justificationKind": {
      "LATE": "Tardanza",
      "EARLY_LEAVE": "Salida anticipada",
      "ABSENCE": "Falta"
    },
    "justificationStatus": {
      "PENDING": "Pendiente",
      "APPROVED": "Aprobada",
      "REJECTED": "Rechazada",
      "CANCELLED": "Cancelada"
    },
    "observedMinutes": "{minutes} min",
    "reason": "Motivo: {reason}",
    "flags": "Observaciones",
    "noFlags": "Sin observaciones.",
    "history": "Historial de evaluaciones",
    "noHistory": "Este día todavía no tiene evaluaciones guardadas: se calcula al consultarlo.",
    "historyColumns": {
      "version": "Versión",
      "computedAt": "Calculada",
      "cause": "Causa",
      "result": "Resultado"
    },
    "historyVersion": "v{version}",
    "cause": {
      "READ": "Consulta",
      "DAILY_JOB": "Proceso diario",
      "CLOSURE": "Cierre de período"
    },
    "historyResult": "{status} · {worked}",
    "historyLate": "{minutes} min tarde",
    "historyEarly": "{minutes} min antes",
    "afterClosure": "Después del cierre"
  },
  "export": {
    "action": "Descargar Excel",
    "pending": "Descargando…",
    "options": {
      "xlsx": "Excel (.xlsx)",
      "csv": "CSV (detalle)"
    },
    "dialog": {
      "title": "Descargar tareo",
      "description": "Un archivo con el tareo del período, dentro de tu alcance.",
      "xlsxHelp": "Excel con las hojas Tareo, Detalle y Leyenda.",
      "csvHelp": "CSV con el detalle: una fila por trabajador y día.",
      "fromDay": "Desde",
      "toDay": "Hasta",
      "maxDays": "Hasta {max} días por archivo.",
      "site": "Sede: {site}",
      "allSites": "Sede: todas las sedes de tu alcance",
      "worker": "Trabajador: {worker}",
      "submit": "Descargar"
    },
    "toastSuccess": "Descargaste {filename}",
    "error": "No pudimos generar el archivo. Inténtalo de nuevo."
  },
  "closure": {
    "periodClosedRange": "El período del {from} al {to} está cerrado. Reábrelo para hacer cambios.",
    "errors": {
      "PERIOD_OVERLAP": "Se cruza con otro período cerrado.",
      "ALREADY_REOPENED": "Este período ya fue reabierto. Actualiza el tareo."
    },
    "closeButton": "Cerrar período",
    "banner": {
      "closedBy": "Período cerrado el {date} por {name} · Los valores son los del cierre",
      "closed": "Período cerrado el {date} · Los valores son los del cierre",
      "range": "Del {from} al {to}. Las marcas corregidas después aparecen con el icono de historial.",
      "reopen": "Reabrir"
    },
    "close": {
      "title": "Cerrar período",
      "description": "Fija los valores del tareo de este período para enviarlo a RRHH.",
      "from": "Desde",
      "to": "Hasta",
      "notice": "No se podrán cambiar horarios, ausencias, feriados ni justificaciones de este período. Las correcciones de marcas siguen permitidas y quedarán señaladas como posteriores al cierre.",
      "toHelp": "Solo días que ya terminaron (hasta ayer).",
      "submit": "Cerrar período",
      "required": "Elige la fecha.",
      "toNotPast": "La fecha final debe ser anterior a hoy.",
      "order": "La fecha final no puede ser anterior a la inicial.",
      "toast": "Cerraste el período del {from} al {to}"
    },
    "reopen": {
      "title": "Reabrir período",
      "description": "Del {from} al {to}. Volverá a ser editable y el tareo mostrará los valores vigentes.",
      "reason": "Motivo",
      "reasonCount": "{count}/{max}",
      "reasonRequired": "Escribe el motivo de la reapertura.",
      "submit": "Reabrir período",
      "toast": "Reabriste el período del {from} al {to}"
    }
  }
}
